<hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__bottom" />
<p class="sp-color__primary sp-text__center">{{ empty_message || '' | translate }}</p>
<hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__top" />
